import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material"
import React from "react"

const NotificationDisplay = props => {
    return (
        <Dialog
            open={props.notifications?.length > 0}
            onClose={props.onClose}
        >
            <DialogTitle id="alert-dialog-title">
          Notifications
        </DialogTitle>
        <DialogContent>
            {
                props.notifications?.map((n, i) => {
                    return <Alert severity="error" key={i}>{n.message || n}</Alert>
                })
            }
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {props?.onClose()}} >Dismiss</Button>
        </DialogActions>
        </Dialog>
    )
}

export default NotificationDisplay;